import React from 'react';
import '../App.css'; // Assuming journey-button styles are in App.css

const CTAButton = ({ onClick, children }) => {
  return (
    <button className="journey-button" onClick={onClick}>
      <span className="journey-button-glow"></span>
      <span className="journey-button-inner">
        <div className="journey-button-content">
          <span className="journey-button-text">
            {children || "Try it now!"}
          </span>
        </div>
      </span>
    </button>
  );
};

export default CTAButton; 